export default __webpack_public_path__ + "static/media/logo_esencial.2e52f744.png";